import { CommentData, PostData, ReplyData } from '../models/data';

export const searchPosts = (
  state: { posts: PostData[] },
  postId: string,
  commentId?: string,
  replyId?: string
): PostData | ReplyData | CommentData | undefined => {
  const post = state.posts.find((post) => post.id === postId);

  if (post && commentId) {
    const comment = post.comments.find((comment) => comment.id === commentId);

    if (comment && replyId) {
      const reply = comment.replies.find((reply) => reply.id === replyId);

      return reply;
    }
    return comment;
  }
  return post;
};
